<div class="confirm-dialog">
 <div class="confirm-header">{{data.title || 'Confirm'}}</div>
 <div class="confirm-body">{{data.message}}</div>
 <div class="confirm-actions">
 <button mat-button class="btn btn-secondary" (click)="cancel()">{{data.cancelText || 'Cancel'}}</button>
 <button mat-raised-button color="primary" class="btn-primary" (click)="confirm()">{{data.confirmText || 'Yes'}}</button>
 </div>
</div>
